import { createFileRoute } from "@tanstack/react-router";
import AdminListingsReview from "@/pages/AdminListingsReview";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/admin/listings-review/")({
  head: () => routeHead("/admin/listings-review/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <AdminListingsReview />
  );
}
